import React from "react"
import PropTypes from "prop-types"

import { Button } from "reactstrap"

import "./style.css"

const PaperButton = ({ onClick, className, disabled, raised, block, rounded, color, children }) => {
    return (
        <Button
            color={color}
            className={[
                block ? "btn-block" : "",
                rounded ? "" : "rounded-0",
                raised & !disabled ? "PaperButton-raised" : "PaperButton-normal",
                className
            ].join(" ")}
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </Button>
    )
}

PaperButton.propTypes = {
    className: PropTypes.string,
    raised: PropTypes.bool,
    onClick: PropTypes.func,
    rounded: PropTypes.bool,
    block: PropTypes.bool,
    disabled: PropTypes.bool,
    color: PropTypes.oneOf(["primary", "secondary", "white", "info", "warning", "danger", "success"])
}

export default PaperButton




// WEBPACK FOOTER //
// ./src/components/simple/PaperButton/index.js